<template>
  <ul class="sidebar-menu">
    <router-link v-for="route in userRol" :key="route.path" :to="`${route.enlaceWeb}`" tag="li" class="pageLink">
      <a>
        <i :class="`${route.icono}`"></i>
        <span class="page fs-12">{{ route.descripcion }}</span>
      </a>
    </router-link>
  </ul>

  <!---
  <ul class="sidebar-menu">
    <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-home"></i>
        <i :class="`{{fa fa-home}}`"></i>
        <span class="page fs-12">INICIO</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/aplication">
      <a>
        <i class="fa fa-tasks"></i>
        <span class="page fs-12">APLICACIONES</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/operaciones">
      <a>
        <i class="fa fa-pie-chart"></i>
        <span class="page fs-12">OPERACIONES</span>
      </a>
    </router-link>    
    <router-link tag="li" class="pageLink" to="/roles">
      <a>
        <i class="fa fa-cog"></i>
        <span class="page fs-12">ROLES</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/areas">
      <a>
        <i class="fa fa-table"></i>
        <span class="page fs-12">ÁREAS</span>
      </a>
    </router-link> 
    <router-link tag="li" class="pageLink" to="/trabajadores">
      <a>
        <i class="fa fa-book"></i>
        <span class="page fs-12">PERSONAL</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/usuariosCas">
      <a>
        <i class="fa fa-user"></i>
        <span class="page fs-12">USUARIOS CAS</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/usuariosAuth">
      <a>
        <i class="fa fa-group"></i>
        <span class="page fs-12">USUARIOS AUTH0</span>
      </a>
    </router-link>
  </ul>
-->
</template>
<script>

export default {
  name: 'SidebarName',
  data() {
    return {
    }
  },
  computed: {
    userRol() {      
      // Obtén el userRol desde el estado del Vuex o desde el localStorage
      //const userRol = this.$store.state.userRol || [];
      const userRol = JSON.parse(localStorage.getItem('userRolData')) || []
      //console.log('Operaciones:', userRol, JSON.parse(localStorage.getItem('userRolData')));
      return userRol;
    },

    /*
    props: {
      userRol: Array,
    },
    */
  },

}
</script>

<style>
.page {
  letter-spacing: 1px
}

.sidebar-menu>li>a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active>a>.fa-angle-left,
.sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
  animation-name: rotate;
  animation-duration: .2s;
  animation-fill-mode: forwards;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?7d18d849